export const RESOURCE_BLOCKS = [
  "Upcoming Events",
  "Phil Blog",
  "Case Study",
  "White Paper",
];

export const POSTS_PER_SECTION = 5; // 5 posts per section is the limit in resources page.

export const RECENT_CLIENT_WINS = 'Recent Client Wins';  

export const DEMO_BANNER_BASIC_SECTION_ID ='3ba4ce2c-791a-5747-a7cd-7b5e9e03ca73';

